const FONT_SCALE_STORAGE_KEY = "ui_font_scale";
const DEFAULT_FONT_SCALE = "1";
const ALLOWED_FONT_SCALES = new Set(["0.9", "0.95", "1", "1.05", "1.1"]);

export const FONT_SCALE_OPTIONS = [
  { value: "0.9", label: "매우 작게" },
  { value: "0.95", label: "작게" },
  { value: "1", label: "기본" },
  { value: "1.05", label: "크게" },
  { value: "1.1", label: "매우 크게" }
];

function normalizeFontScale(scale) {
  const value = String(scale ?? DEFAULT_FONT_SCALE);
  return ALLOWED_FONT_SCALES.has(value) ? value : DEFAULT_FONT_SCALE;
}

export function getSavedFontScale() {
  if (typeof window === "undefined") return DEFAULT_FONT_SCALE;
  try {
    return normalizeFontScale(window.localStorage.getItem(FONT_SCALE_STORAGE_KEY));
  } catch {
    return DEFAULT_FONT_SCALE;
  }
}

export function applyFontScale(scale) {
  const normalized = normalizeFontScale(scale);
  if (typeof document !== "undefined") {
    document.documentElement.style.setProperty("--app-font-scale", normalized);
  }
  return normalized;
}

export function saveFontScale(scale) {
  const normalized = normalizeFontScale(scale);
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(FONT_SCALE_STORAGE_KEY, normalized);
    } catch {
      // Ignore localStorage write failures.
    }
  }
  return normalized;
}
